import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useState } from "react";
import toast from "react-hot-toast";
import { HiMagnifyingGlassPlus } from "react-icons/hi2";

export default function ProdutoDetalhado({
  product,
  galleryIndex,
  onGalleryChange,
  onToggleCart,
  isInCart,
  onBuyProduct,
  onNavigateHome,
  relatedProducts = [],
  onOpenProduct,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [zoomAtivo, setZoomAtivo] = useState(false);
  const [zoomPosicao, setZoomPosicao] = useState({ x: 50, y: 50 });

  const finalizarCompra = () => {
    if (!product.estoque || product.estoque <= 0) {
      toast.error("Produto fora de estoque!");
      return;
    }

    if (!user) {
      navigate("/login", {
        state: { message: "Faça login para finalizar sua compra" },
      });
      return;
    } else {
      if (!isInCart) {
        onToggleCart(product.id);
        navigate("/checkout");
      } else {
        navigate("/checkout");
      }
    }
  };

  if (!product)
    return <div className="loading-detalhe">Carregando detalhes...</div>;

  const fotos = product.fotos || [];
  const imagemAtual = fotos[galleryIndex] || fotos[0] || null;
  const precoOriginal = Number(product.precoOriginal ?? product.preco ?? 0);
  const precoAtual = Number(product.preco ?? 0);
  const temDesconto = precoOriginal > precoAtual;

  const handleZoomMove = (event) => {
    if (!zoomAtivo) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    setZoomPosicao({
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    });
  };

  //
  return (
    <div className="produto-topo">
      <div className="produto-topo-inner">
        <button type="button" className="btn-voltar" onClick={onNavigateHome}>
          ← Voltar ao catálogo
        </button>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-atual">{product.nome}</span>
      </div>

      <div className="produto-layout">
        <div className="produto-galeria">
          <div
            className={`galeria-principal ${zoomAtivo ? "zoom-ativo" : ""}`}
            onMouseMove={handleZoomMove}
            onMouseLeave={() => setZoomAtivo(false)}
            onClick={() => setZoomAtivo(false)}
          >
            {imagemAtual ? (
              <img
                className="galeria-imagem-ativa"
                src={imagemAtual}
                alt={product.nome}
              />
            ) : (
              <div className="galeria-placeholder">Sem imagem</div>
            )}

            {imagemAtual && (
              <div
                className={`galeria-zoom ${zoomAtivo ? "ativo" : ""}`}
                aria-hidden="true"
                style={{
                  backgroundImage: `url(${imagemAtual})`,
                  backgroundPosition: `${zoomPosicao.x}% ${zoomPosicao.y}%`,
                }}
              />
            )}

            {imagemAtual && (
              <button
                type="button"
                className="galeria-lupa-btn"
                aria-label={zoomAtivo ? "Desativar zoom" : "Ativar zoom"}
                onClick={(event) => {
                  event.stopPropagation();
                  setZoomAtivo((ativo) => !ativo);
                }}
              >
                <HiMagnifyingGlassPlus />
              </button>
            )}

            {fotos.length > 1 && (
              <div className="galeria-nav">
                <button
                  type="button"
                  className="galeria-btn-nav"
                  aria-label="Imagem anterior"
                  onClick={() =>
                    onGalleryChange(
                      (galleryIndex - 1 + fotos.length) % fotos.length,
                    )
                  }
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="galeria-btn-nav"
                  aria-label="Próxima imagem"
                  onClick={() =>
                    onGalleryChange((galleryIndex + 1) % fotos.length)
                  }
                >
                  ›
                </button>
              </div>
            )}

            <div className="galeria-contador">
              {galleryIndex + 1}/{fotos.length || 1}
            </div>
          </div>

          <div className="galeria-miniaturas">
            {fotos.map((foto, index) => (
              <button
                key={index}
                className={`galeria-miniatura ${galleryIndex === index ? "ativa" : ""}`}
                onClick={() => onGalleryChange(index)}
              >
                <img src={foto} alt={`${product.nome} ${index + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="produto-info">
          <span className="produto-categoria-tag">
            {product.categoriaLabel}
          </span>
          <h1 className="produto-nome">{product.nome}</h1>
          <div className="produto-preco-group">
            {temDesconto && (
              <span className="produto-preco-antigo">
                R${" "}
                {precoOriginal.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </span>
            )}
            <div className="produto-preco">
              <span>R$</span>
              {precoAtual.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}
            </div>
          </div>
          <hr className="produto-divisor" />

          <div className="produto-descricao-secao">
            <div className="produto-descricao-titulo">Descrição</div>
            <p className="produto-descricao-texto">
              {product.descricao || "Sem descrição disponível."}
            </p>
          </div>

          <div className="produto-acoes">
            <button
              type="button"
              className={`btn-produto-carrinho ${isInCart ? "adicionado" : ""}`}
              onClick={() => onToggleCart(product.id)}
            >
              {isInCart ? "Remover do carrinho" : "Adicionar ao carrinho"}
            </button>
            <button
              type="button"
              className="btn-produto-carrinho"
              onClick={() => finalizarCompra()}
            >
              Finalizar Compra
            </button>
          </div>

          {/* --- SEÇÃO DE INFORMAÇÕES DINÂMICA --- */}
          <div className="produto-detalhes">
            <div className="produto-detalhes-titulo">
              Informações Adicionais
            </div>

            {/* Mantemos Categoria e Disponibilidade como fixas/base */}
            <div className="produto-detalhe-linha">
              <span className="produto-detalhe-label">Estoque</span>
              <span className="produto-detalhe-valor">{product.estoque}</span>
            </div>
            <div className="produto-detalhe-linha">
              <span className="produto-detalhe-label">Categoria</span>
              <span className="produto-detalhe-valor">
                {product.categoriaLabel}
              </span>
            </div>
            <div className="produto-detalhe-linha">
              <span className="produto-detalhe-label">Disponibilidade</span>
              <span className="produto-detalhe-valor">
                {product.disponivel ? "Pronta Entrega" : "Sob Encomenda"}
              </span>
            </div>

            {/* MAPEAMENTO DAS CHAVES E VALORES DO DASHBOARD */}
            {product.informacoesAdicionais &&
              product.informacoesAdicionais.map((info, idx) => (
                <div key={idx} className="produto-detalhe-linha">
                  <span className="produto-detalhe-label">{info.chave}</span>
                  <span className="produto-detalhe-valor">{info.valor}</span>
                </div>
              ))}
          </div>
        </div>
      </div>

      {relatedProducts.length > 0 && (
        <section className="produtos-relacionados">
          <h2 className="relacionados-titulo">Produtos relacionados</h2>
          <div className="grid-relacionados">
            {relatedProducts.map((item, index) => {
              const hasFoto = item.fotos && item.fotos.length > 0;
              return (
                <article
                  key={item.id}
                  className="card-produto card-relacionado"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => onOpenProduct(item.id)}
                >
                  <div className="card-imagem-wrapper">
                    {hasFoto ? (
                      <img
                        src={item.fotos[0]}
                        alt={item.nome}
                        className="card-imagem"
                      />
                    ) : (
                      <div className="card-placeholder">
                        <div className="card-placeholder-icone">
                          {item.icone || "◈"}
                        </div>
                        <div className="card-placeholder-texto">
                          Imagem em breve
                        </div>
                      </div>
                    )}
                    <span className="card-badge">{item.categoriaLabel}</span>
                    <div className="card-overlay">
                      <button
                        type="button"
                        className="btn-ver-produto"
                        onClick={(event) => {
                          event.stopPropagation();
                          onOpenProduct(item.id);
                        }}
                      >
                        Ver produto
                      </button>
                    </div>
                  </div>

                  <div className="card-corpo">
                    <span className="card-categoria">
                      {item.categoriaLabel}
                    </span>
                    <h3 className="card-nome">{item.nome}</h3>
                    <p className="card-descricao">
                      {item.descricao?.substring(0, 85) ||
                        "Sem descrição disponível."}
                      ...
                    </p>
                    <div className="card-rodape">
                      <div className="card-preco">
                        <span>R$</span>
                        {item.preco?.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                      <button
                        type="button"
                        className="btn-detalhes"
                        onClick={(event) => {
                          event.stopPropagation();
                          onOpenProduct(item.id);
                        }}
                      >
                        Ver detalhes
                      </button>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
}
